export function getQuestionsData(questionsData) {
  if (!questionsData) return { questions: [] };
  const questions = !questionsData.questions
    ? []
    : Object.keys(questionsData.questions).map((key) => questionsData.questions[key]);
  return {
    ...questionsData,
    questions,
  };
}

export const getEvaluation = (data) => {
  const titles = data.evaluation.catalogings.map((c) => c.name);
  switch (titles.length) {
    case 0:
      return data;
    case 1:
      return { ...data, title: titles[0] };
    default:
      const lastCataloging = titles[titles.length - 1];
      const catalogingsArray = titles.slice(0, titles.length - 1).join(', ');
      const title = catalogingsArray.concat(` e ${lastCataloging}`);
      return { ...data, title };
  }
};
